var React = require('react');

function Login (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-4.836-4.247a1 1 0 0 0-1.411.083l-5.267 5.925-2.251-2.44a1 1 0 0 0-1.47 1.357l2.626 2.845a1.5 1.5 0 0 0 2.12.085l.053-.052a2.27 2.27 0 0 0 .05-.054l5.633-6.338a1 1 0 0 0-.083-1.411Z","fill":"#6cba68"}));
}

Login.defaultProps = {"width":"18","height":"18","viewBox":"0 0 24 24","fill":"none"};

module.exports = Login;

Login.default = Login;
